import * as Log from '../../util/log';
import * as Actions from '../../actions/actions';
import { BUILD_VERSION } from '../../constants';
import APIResponse from '../../model/api/APIResponse';
import { captureDebug } from '../../util/sentry';

let dispatch = null;

export const setDispatch = (dispatchInstance) => {
  dispatch = dispatchInstance;
};

function handleVersionError(version) {
  Log.error(
    `Application build version ${BUILD_VERSION} is incompatible with response version ${version}.`,
  );

  dispatch({
    type: Actions.UNSUPPORTED_VERSION_ERROR,
  });
}

/**
 *
 * @param {function} method - API Method to wrap that must return a Promise
 * @returns {function(...[*]): Promise<APIResponse>}
 */
export const wrapAPICall = (method) => {
  /* @return {Promise<APIResponse>} */
  return (...args) => {
    return new Promise((resolve, reject) => {
      return method(...args)
        .then(({ data }) => {
          const response = new APIResponse(true, data);
          resolve(response);
        })
        .catch((error) => {
          captureDebug(error);

          if (error.$versionError) {
            handleVersionError(error.version);
          }

          const response = new APIResponse(false, null, error);
          resolve(response);
        });
    });
  };
};
